module.exports = __webpack_public_path__ + "media/images/mypage/btn01_ov-fb8f205fc9283e718f41681b23c4fdfb.gif";